import React from 'react';
import { Editor } from '@tiptap/react';

import CommentIcon from '@mui/icons-material/Comment';

import { Button } from 'containers/Tiptap/components/tiptap-ui-primitive/button';

const CommentButton: React.FC<{
  editor: Editor;
  addComment: () => void;
}> = ({ editor, addComment }) => {
  const handleAddComment = (): void => {
    if (!editor) return;

    const { selection } = editor.state;
    if (selection.empty) return;

    addComment();
  };

  const canAddComment = editor && !editor.state.selection.empty;

  return (
    <Button
      type="button"
      data-style="ghost"
      role="button"
      tabIndex={-1}
      onClick={handleAddComment}
      disabled={!canAddComment}
    >
      <CommentIcon style={{ fontSize: '16px' }} />
      <span style={{ fontSize: '14px' }}>Comment</span>
    </Button>
  );
};

export default CommentButton;
